import React, {useEffect, useState} from "react";
import api from "../../services/api";
import TitleH1 from "../Titles/title-h1";

const AdminBooks = () => {
    const [books, setBooks] = useState([]);

    useEffect(() => {
        api.get('/handleBooks')
            .then((response) => {
                setBooks(response.data.books);
            })
            .catch((error) => {
                console.error('Failed to fetch books', error);
            })
    }, []);

    const handleDelete = (id) => {
        api.delete(`/deleteBook/${id}`)
            .then((response) => {
                setBooks(prevBooks => prevBooks.filter(book => book.id !== id));
                console.log(response.data.message);
            })
            .catch((error) => {
                console.error('Failed to delete book:', error.response?.data?.message || error.message);
            });
    }


    return (
        <>
            <TitleH1>Books</TitleH1>
            <table className="w-full border-collapse bg-white rounded-lg shadow">
                <thead className="bg-gray-100 text-gray-600 text-sm uppercase font-semibold">
                <tr>
                    <th className="py-3 px-6 text-left">Name</th>
                    <th className="py-3 px-6 text-center">Edit</th>
                    <th className="py-3 px-6 text-center">Delete</th>
                </tr>
                </thead>
                <tbody>
                {books.map((book) => (
                    <tr>
                        <td id={book.id} className="py-3 px-6 text-left">{book.title}</td>
                        <td className="py-3 px-6 text-center">
                            <button
                                className="text-blue-600 hover:text-blue-800 transition duration-300"
                                aria-label="Edit Author"
                            >
                                <svg
                                    className="h-5 w-5 inline"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M15.232 5.232l3.536 3.536M9 13l3.536-3.536L15 9l3.536 3.536L13 15l-3.536 3.536L9 15z"
                                    ></path>
                                </svg>
                            </button>
                        </td>
                        <td className="py-3 px-6 text-center">
                            <button
                                onClick={() => handleDelete(book.id)}
                                className="text-red-600 hover:text-red-800 transition duration-300"
                                aria-label="Delete Author"
                            >
                                <svg
                                    className="h-5 w-5 inline"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    ></path>
                                </svg>
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </>
    )
}

export default AdminBooks;